import { Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export const AiBadge = () => (
  <Chip
    icon={<AutoAwesomeIcon sx={{ fontSize: '12px !important' }} />}
    label='Auto-generated'
    size='small'
    sx={{
      height: 20,
      fontSize: '0.6rem',
      px: 0.15,
      backgroundColor: 'rgba(74, 158, 110, 0.15)',
      color: 'secondary.main',
      '& .MuiChip-icon': { color: 'secondary.main' },
    }}
  />
);
